/**
 * Null INP1 Provider - no-op implementation
 */
import { EventEmitter } from 'eventemitter3';
export class NullInp1Provider extends EventEmitter {
    async init() {
        return true;
    }
    end() { }
    job(_ecu, _job, _arg1, _arg2) { }
    state() {
        return 0; // idle
    }
    resultText(_result, _set, _format) {
        return [false, ''];
    }
    resultInt(_result, _set) {
        return [false, 0];
    }
    resultSets() {
        return [true, 0];
    }
    resultReal(_result, _set) {
        return [false, 0];
    }
    resultBinary(_result, _set) {
        return [false, new Uint8Array(0)];
    }
    errorCode() {
        return 0;
    }
    errorText() {
        return '';
    }
}
//# sourceMappingURL=inp1.js.map